import { useState } from "react";
import styles from "./RequestAssessment.module.scss";
import { ModalOverlay } from "../ModalOverlay";
import { Button } from "../common/Button";
import { AssessmentInviteForm } from '../AssessmentInviteForm';
import { AssessmentInviteData } from '../../apollo/types/AssessmentInviteData';
import { useMutation } from '@apollo/client';
import { ASSESSMENTS_INVITES, SEND_ASSESSMENT_INVITE } from '../../apollo/queries';
import { AssessmentRoute } from '../../apollo/types/AssessmentRoute';
import { client } from '../../apollo/client';
import classNames from 'classnames';

type RequestAssessmentRoutes = {
    routes: [AssessmentRoute] | []
    button?: boolean
    isOpen: boolean,
    onOpenChange: Function
    preSelectedAssessmentRoute?: null | number
}


export const RequestAssessment = ({
    routes,
    onOpenChange,
    isOpen = false,
    button = true,
    preSelectedAssessmentRoute = null
}: RequestAssessmentRoutes) => {
  // const [isOpen, setIsOpen] = useState(false);
  const [sendingSuccessful, setSendingSuccessful] = useState(false);
  const [errorFound, setErrorFound] = useState(false);

    const [sendInviteAction] = useMutation(SEND_ASSESSMENT_INVITE, {
        onCompleted: (data) => {
            if(data !== null && data.sendInvite.code === 200) {
                setSendingSuccessful(true)
                setErrorFound(false)
                client.refetchQueries({
                    include: [ASSESSMENTS_INVITES]
                })
                setTimeout(() => {
                    onOpenChange(!isOpen);
                    setSendingSuccessful(false)
                }, 1500)
            }
        },
        onError: () => {
            setErrorFound(true)
            setTimeout(() => {
                onOpenChange(!isOpen);
                setSendingSuccessful(false)
                setErrorFound(false)
            }, 2500)
        }
    });

  const handleSendEmail = async (formData: AssessmentInviteData, message: String) => {
    sendInviteAction({
        variables: {
            name: formData.name,
            emailAddress: formData.emailAddress,
            venture: formData.venture,
            language: formData.language,
            message,
            assessmentRoute: formData.assessmentRoute,
            tags: formData.tags
        },
    })
  };

  const handleOpenSend = () => {
      onOpenChange(!isOpen);
  };

  return (
    <div className={classNames(styles.wrapper, styles.buttonWrapper)}>
        {button &&
          <Button className="dark" onClick={handleOpenSend}>
            Request scan
          </Button>
        }
      <ModalOverlay show={isOpen}>
        <AssessmentInviteForm
          isOpen={isOpen}
          onToggle={handleOpenSend}
          onClick={handleSendEmail}
          sendingSuccessful={sendingSuccessful}
          routes={routes}
          errorFound={errorFound}
          preSelectedAssessmentRoute={preSelectedAssessmentRoute}
        />
      </ModalOverlay>
    </div>
  );
};
